const $ = require('jquery');
window.$ = $;
require('bootstrap');
require('slick-slider');
// window.Readmore = require('readmore-js');
const TopSystems = require('./topsystems');

